// Generated by purs version 0.15.16
import * as API_SelStudent from "../API.SelStudent/index.js";
import * as App_Route from "../App.Route/index.js";
import * as Concur_Core_LiftWidget from "../Concur.Core.LiftWidget/index.js";
import * as Concur_Core_Types from "../Concur.Core.Types/index.js";
import * as Concur_React_DOM from "../Concur.React.DOM/index.js";
import * as Concur_React_Props from "../Concur.React.Props/index.js";
import * as Control_Comonad_Cofree from "../Control.Comonad.Cofree/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_List from "../Data.List/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as GraphQL_Type from "../GraphQL.Type/index.js";
import * as Internal_ConcurUtil from "../Internal.ConcurUtil/index.js";
import * as Internal_SelectionMap from "../Internal.SelectionMap/index.js";
import * as Steps_WorkQueue_Cache from "../Steps.WorkQueue.Cache/index.js";
import * as Steps_WorkQueue_DocumentIndex from "../Steps.WorkQueue.DocumentIndex/index.js";
import * as Steps_WorkQueue_State from "../Steps.WorkQueue.State/index.js";
import * as Steps_WorkQueue_UIState from "../Steps.WorkQueue.UIState/index.js";
import * as Translate from "../Translate/index.js";
import * as Widgets_Loading from "../Widgets.Loading/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var fromFoldable = /* #__PURE__ */ Data_Array.fromFoldable(Data_List_Types.foldableList);
var eqRNTY = /* #__PURE__ */ GraphQL_Type.eqRNTY(Data_Eq.eqString);
var eq = /* #__PURE__ */ Data_Eq.eq(eqRNTY);
var append1 = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var multiAlternativeWidget = /* #__PURE__ */ Concur_Core_Types.multiAlternativeWidget(Data_Monoid.monoidArray);
var li = /* #__PURE__ */ Concur_React_DOM.li(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var text = /* #__PURE__ */ Concur_React_DOM.text(Concur_Core_LiftWidget.liftWidgetWidget);
var ordRNTY = /* #__PURE__ */ GraphQL_Type.ordRNTY(Data_Ord.ordString);
var nub = /* #__PURE__ */ Data_Array.nub(ordRNTY);
var span = /* #__PURE__ */ Concur_React_DOM.span(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var span$prime = /* #__PURE__ */ Concur_React_DOM["span$prime"](multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var li$prime = /* #__PURE__ */ Concur_React_DOM["li$prime"](multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var a = /* #__PURE__ */ Concur_React_DOM.a(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var map1 = /* #__PURE__ */ Data_Functor.map(Concur_React_Props.functorProps);
var ul$prime = /* #__PURE__ */ Concur_React_DOM["ul$prime"](multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var toUnfoldable = /* #__PURE__ */ Data_List.toUnfoldable(Data_Unfoldable.unfoldableArray);
var ul = /* #__PURE__ */ Concur_React_DOM.ul(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var eq1 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
    reflectSymbol: function () {
        return "studentId";
    }
})(eqRNTY))()({
    reflectSymbol: function () {
        return "formId";
    }
})(eqRNTY))()({
    reflectSymbol: function () {
        return "documentId";
    }
})(/* #__PURE__ */ Data_Maybe.eqMaybe(eqRNTY))));
var elem = /* #__PURE__ */ Data_Array.elem(eqRNTY);
var button = /* #__PURE__ */ Concur_React_DOM.button(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var lookup = /* #__PURE__ */ Data_Map_Internal.lookup(ordRNTY);
var length = /* #__PURE__ */ Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt);
var details = /* #__PURE__ */ Concur_React_DOM.details(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var summary = /* #__PURE__ */ Concur_React_DOM.summary(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var insert = /* #__PURE__ */ Data_Map_Internal.insert(ordRNTY);
var voidRight = /* #__PURE__ */ Data_Functor.voidRight(Concur_React_Props.functorProps);
var div = /* #__PURE__ */ Concur_React_DOM.div(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var fromFoldable1 = /* #__PURE__ */ Data_Map_Internal.fromFoldable(ordRNTY)(Data_List_Types.foldableList);
var map2 = /* #__PURE__ */ Data_Functor.map(Data_List_Types.functorList);
var header = /* #__PURE__ */ Concur_React_DOM.header(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var UIStateChange = /* #__PURE__ */ (function () {
    function UIStateChange(value0) {
        this.value0 = value0;
    };
    UIStateChange.create = function (value0) {
        return new UIStateChange(value0);
    };
    return UIStateChange;
})();
var JumpToForm = /* #__PURE__ */ (function () {
    function JumpToForm(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    JumpToForm.create = function (value0) {
        return function (value1) {
            return new JumpToForm(value0, value1);
        };
    };
    return JumpToForm;
})();
var ExistingDocument = /* #__PURE__ */ (function () {
    function ExistingDocument(value0) {
        this.value0 = value0;
    };
    ExistingDocument.create = function (value0) {
        return new ExistingDocument(value0);
    };
    return ExistingDocument;
})();
var NewDocument = /* #__PURE__ */ (function () {
    function NewDocument(value0) {
        this.value0 = value0;
    };
    NewDocument.create = function (value0) {
        return new NewDocument(value0);
    };
    return NewDocument;
})();
var itemLookup = function (student) {
    return function (v) {
        if (v instanceof ExistingDocument) {
            return {
                studentId: v.value0.student.id,
                formId: v.value0.form_type.id,
                documentId: new Data_Maybe.Just(v.value0.id)
            };
        };
        if (v instanceof NewDocument) {
            return {
                studentId: student.id,
                formId: v.value0.id,
                documentId: Data_Maybe.Nothing.value
            };
        };
        throw new Error("Failed pattern match at Steps.WorkQueue.View (line 259, column 22 - line 269, column 10): " + [ v.constructor.name ]);
    };
};
var itemLabel = function (v) {
    if (v instanceof ExistingDocument) {
        return v.value0.form_type.label;
    };
    if (v instanceof NewDocument) {
        return v.value0.label;
    };
    throw new Error("Failed pattern match at Steps.WorkQueue.View (line 277, column 13 - line 279, column 35): " + [ v.constructor.name ]);
};
var itemKey = function (student) {
    return function (v) {
        if (v instanceof ExistingDocument) {
            return "existing:" + GraphQL_Type.innerId(v.value0.id);
        };
        if (v instanceof NewDocument) {
            return "new:" + (GraphQL_Type.innerId(student.id) + (":" + GraphQL_Type.innerId(v.value0.id)));
        };
        throw new Error("Failed pattern match at Steps.WorkQueue.View (line 282, column 19 - line 284, column 79): " + [ v.constructor.name ]);
    };
};
var itemFormId = function (v) {
    if (v instanceof ExistingDocument) {
        return v.value0.form_type.id;
    };
    if (v instanceof NewDocument) {
        return v.value0.id;
    };
    throw new Error("Failed pattern match at Steps.WorkQueue.View (line 272, column 14 - line 274, column 32): " + [ v.constructor.name ]);
};
var renderStudentDetails = function (preservedQuery) {
    return function (state) {
        return function (ui) {
            return function (cache) {
                return function (student) {
                    var studentForms = (function () {
                        var newForms = map(NewDocument.create)(fromFoldable(Internal_SelectionMap.listSelected(state.forms)));
                        var existingDocs = map(ExistingDocument.create)(Data_Array.filter(function (d) {
                            return eq(d.student.id)(student.id);
                        })(state.editDocs));
                        return append1(existingDocs)(newForms);
                    })();
                    var renderStudentNoForms = li([ Concur_React_Props.className("workqueue-student no-forms") ])([ text(API_SelStudent.studentName(cache.account)(student)) ]);
                    var renderStudentForm = function (item) {
                        var routeDocIds = nub(append1(map(function (v) {
                            return v.id;
                        })(state.editDocs))(map(function (v) {
                            return v.id;
                        })(fromFoldable(Steps_WorkQueue_DocumentIndex.listDocs(state.documents)))));
                        var sectionHref = function (currentItem) {
                            return function (sectionId) {
                                if (currentItem instanceof ExistingDocument) {
                                    return App_Route.routeUrl(new App_Route.RStep3({
                                        preservedQuery: preservedQuery,
                                        activeDoc: new Data_Maybe.Just(currentItem.value0.id),
                                        docs: routeDocIds,
                                        section: new App_Route.SectionSet(sectionId)
                                    }));
                                };
                                if (currentItem instanceof NewDocument) {
                                    return App_Route.sectionHash(new Data_Maybe.Just(sectionId));
                                };
                                throw new Error("Failed pattern match at Steps.WorkQueue.View (line 238, column 45 - line 247, column 54): " + [ currentItem.constructor.name ]);
                            };
                        };
                        var renderFormLabel = function (label) {
                            return function (locked) {
                                return [ span([ Concur_React_Props.className("workqueue-form-label") ])(append1((function () {
                                    if (locked) {
                                        return [ span([ Concur_React_Props.className("workqueue-lock-indicator") ])([  ]) ];
                                    };
                                    return [  ];
                                })())([ span$prime([ text(label) ]) ])) ];
                            };
                        };
                        var lookup1 = itemLookup(student)(item);
                        var renderSection = function (tree) {
                            var node = Control_Comonad_Cofree.head(tree);
                            return li$prime([ a([ map1(JumpToForm.create({
                                lookup: lookup1,
                                section: new Data_Maybe.Just(node.id)
                            }))(Concur_React_Props.onClick), Concur_React_Props.href(sectionHref(item)(node.id)) ])([ text(node.workQueueLabel) ]), ul$prime(map(renderSection)(toUnfoldable(Control_Comonad_Cofree.tail(tree)))) ]);
                        };
                        var renderSections = function (form$prime) {
                            return ul([ Concur_React_Props.className("student-form-section") ])(map(renderSection)(form$prime.sections));
                        };
                        var isLocked = Steps_WorkQueue_Cache.isLockedDocument(state)(lookup1);
                        var isCurrentWorkQueueItem = function (candidate) {
                            if (state.currentDoc instanceof Data_Maybe.Nothing) {
                                return false;
                            };
                            if (state.currentDoc instanceof Data_Maybe.Just) {
                                var $97 = eq1(state.currentDoc.value0)(candidate);
                                if ($97) {
                                    return true;
                                };
                                if (state.currentDoc.value0.documentId instanceof Data_Maybe.Just) {
                                    return Data_Maybe.isNothing(candidate.documentId) && (!elem(state.currentDoc.value0.documentId.value0)(map(function (v) {
                                        return v.id;
                                    })(state.editDocs)) && Data_Maybe.maybe(false)(function (doc) {
                                        return eq(doc.student.id)(candidate.studentId) && eq(doc.formId)(candidate.formId);
                                    })(Steps_WorkQueue_Cache.getDocByStudent(state)(state.currentDoc.value0)));
                                };
                                if (state.currentDoc.value0.documentId instanceof Data_Maybe.Nothing) {
                                    return false;
                                };
                                throw new Error("Failed pattern match at Steps.WorkQueue.View (line 161, column 22 - line 168, column 37): " + [ state.currentDoc.value0.documentId.constructor.name ]);
                            };
                            throw new Error("Failed pattern match at Steps.WorkQueue.View (line 157, column 44 - line 168, column 37): " + [ state.currentDoc.constructor.name ]);
                        };
                        var isCurrent = isCurrentWorkQueueItem(lookup1);
                        var existingDocumentHref = function (recentForm) {
                            return App_Route.routeUrl(new App_Route.RStep3({
                                preservedQuery: preservedQuery,
                                activeDoc: new Data_Maybe.Just(recentForm.id),
                                docs: routeDocIds,
                                section: App_Route.SectionClear.value
                            }));
                        };
                        var formAnchor = function (handleJump) {
                            if (item instanceof ExistingDocument) {
                                return a(append1([ Concur_React_Props.key(itemKey(student)(item) + (":" + (function () {
                                    if (isLocked) {
                                        return "locked";
                                    };
                                    return "unlocked";
                                })())), Concur_React_Props.className("workqueue-form-link" + (function () {
                                    if (isCurrent) {
                                        return " workqueue-selected";
                                    };
                                    return "";
                                })()), Concur_React_Props.href(existingDocumentHref(item.value0)) ])((function () {
                                    if (handleJump) {
                                        return [ map1(JumpToForm.create({
                                            lookup: lookup1,
                                            section: Data_Maybe.Nothing.value
                                        }))(Concur_React_Props.onClick) ];
                                    };
                                    return [  ];
                                })()))(renderFormLabel(itemLabel(item))(isLocked));
                            };
                            if (item instanceof NewDocument) {
                                return button(append1([ Concur_React_Props.key(itemKey(student)(item) + (":" + (function () {
                                    if (isLocked) {
                                        return "locked";
                                    };
                                    return "unlocked";
                                })())), Concur_React_Props.className("workqueue-form-link" + (function () {
                                    if (isCurrent) {
                                        return " workqueue-selected";
                                    };
                                    return "";
                                })()), Concur_React_Props["_type"]("button") ])((function () {
                                    if (handleJump) {
                                        return [ map1(JumpToForm.create({
                                            lookup: lookup1,
                                            section: Data_Maybe.Nothing.value
                                        }))(Concur_React_Props.onClick) ];
                                    };
                                    return [  ];
                                })()))(renderFormLabel(itemLabel(item))(isLocked));
                            };
                            throw new Error("Failed pattern match at Steps.WorkQueue.View (line 177, column 33 - line 204, column 64): " + [ item.constructor.name ]);
                        };
                        var cachedFormMaybe = lookup(itemFormId(item))(cache.formCache);
                        var liAttrs = append1([ Concur_React_Props.key(itemKey(student)(item)) ])((function () {
                            var $110 = Data_Maybe.isNothing(cachedFormMaybe);
                            if ($110) {
                                return [ Concur_React_Props.className("workqueue-form-no-sections") ];
                            };
                            return [  ];
                        })());
                        return li(liAttrs)([ (function () {
                            if (cachedFormMaybe instanceof Data_Maybe.Just) {
                                var $112 = length(cachedFormMaybe.value0.sections) > 0;
                                if ($112) {
                                    return details([ Concur_React_Props.open(isCurrent) ])([ summary([ Concur_React_Props.className("summary-form summary-form-sections") ])([ formAnchor(true) ]), renderSections(cachedFormMaybe.value0) ]);
                                };
                                return formAnchor(true);
                            };
                            if (cachedFormMaybe instanceof Data_Maybe.Nothing) {
                                return formAnchor(true);
                            };
                            throw new Error("Failed pattern match at Steps.WorkQueue.View (line 139, column 11 - line 148, column 39): " + [ cachedFormMaybe.constructor.name ]);
                        })() ]);
                    };
                    var renderStudentForms = ul([ Concur_React_Props.className("workqueue-student-forms") ])(map(renderStudentForm)(studentForms));
                    var openProp = function (v) {
                        if (v) {
                            return [ Concur_React_Props.open(true) ];
                        };
                        if (!v) {
                            return [  ];
                        };
                        throw new Error("Failed pattern match at Steps.WorkQueue.View (line 134, column 5 - line 134, column 36): " + [ v.constructor.name ]);
                    };
                    var isOpen = (function () {
                        var v = lookup(student.id)(ui.expandedStudents);
                        if (v instanceof Data_Maybe.Just && v.value0 instanceof Steps_WorkQueue_UIState.Expanded) {
                            return true;
                        };
                        if (v instanceof Data_Maybe.Just && v.value0 instanceof Steps_WorkQueue_UIState.Collapsed) {
                            return false;
                        };
                        if (v instanceof Data_Maybe.Nothing) {
                            return Data_Maybe.maybe(false)(function (c) {
                                return eq(c.studentId)(student.id);
                            })(state.currentDoc);
                        };
                        throw new Error("Failed pattern match at Steps.WorkQueue.View (line 129, column 14 - line 132, column 82): " + [ v.constructor.name ]);
                    })();
                    var toggleExpanded = insert(student.id)((function () {
                        if (isOpen) {
                            return Steps_WorkQueue_UIState.Collapsed.value;
                        };
                        return Steps_WorkQueue_UIState.Expanded.value;
                    })())(ui.expandedStudents);
                    var renderStudentAndForms = li([ Concur_React_Props.className("workqueue-student") ])([ details(append1([ Concur_React_Props.key("student-details-" + (GraphQL_Type.innerId(student.id) + ("-" + (function () {
                        if (isOpen) {
                            return "open";
                        };
                        return "closed";
                    })()))) ])(openProp(isOpen)))([ summary([ voidRight(new UIStateChange({
                        search: ui.search,
                        teacher: ui.teacher,
                        semester: ui.semester,
                        expandedStudents: toggleExpanded
                    }))(Concur_React_Props.onClick), Concur_React_Props.className("summary-student") ])([ text(API_SelStudent.studentName(cache.account)(student)) ]), renderStudentForms ]) ]);
                    var $120 = length(studentForms) <= 0;
                    if ($120) {
                        return renderStudentNoForms;
                    };
                    return renderStudentAndForms;
                };
            };
        };
    };
};
var renderStudentList = function (preservedQuery) {
    return function (state) {
        return function (ui) {
            return function (cache) {
                return div([ Concur_React_Props.className("workqueue-students") ])(map(renderStudentDetails(preservedQuery)(state)(ui)(cache))(fromFoldable(Internal_SelectionMap.listSelected(state.students))));
            };
        };
    };
};
var workQueueWidgetWithRoute = function (preservedQuery) {
    return function (state) {
        return function (ui) {
            return function (cache) {
                var expansionForAll = function (expansion) {
                    return fromFoldable1(map2(function (student) {
                        return new Data_Tuple.Tuple(student.id, expansion);
                    })(Internal_SelectionMap.listSelected(state.students)));
                };
                var expandBtns = div([ Concur_React_Props.className("expand-collapse-buttons") ])([ button([ voidRight(new UIStateChange({
                    search: ui.search,
                    teacher: ui.teacher,
                    semester: ui.semester,
                    expandedStudents: expansionForAll(Steps_WorkQueue_UIState.Expanded.value)
                }))(Concur_React_Props.onClick), Concur_React_Props.className("expand-all") ])([ text("Expand all") ]), button([ voidRight(new UIStateChange({
                    search: ui.search,
                    teacher: ui.teacher,
                    semester: ui.semester,
                    expandedStudents: expansionForAll(Steps_WorkQueue_UIState.Collapsed.value)
                }))(Concur_React_Props.onClick), Concur_React_Props.className("collapse-all") ])([ text("Collapse all") ]) ]);
                return div([ Concur_React_Props.className("workqueue") ])(append1([ renderStudentList(preservedQuery)(state)(ui)(cache) ])((function () {
                    var $121 = Steps_WorkQueue_State.isWorkQueueEmpty(state);
                    if ($121) {
                        return [  ];
                    };
                    return [ expandBtns ];
                })()));
            };
        };
    };
};
var workQueueWidget = /* #__PURE__ */ workQueueWidgetWithRoute(/* #__PURE__ */ App_Route.preserveQuery(""));
var loadingWidgetWQ = function (state) {
    return function (ui) {
        return function (cache) {
            return div([ Concur_React_Props.className("step-container") ])([ div([ Concur_React_Props.className("page-header") ])([ header([ Concur_React_Props.className("page-heading") ])([ text(Translate.lookupTranslation("loading")) ]) ]), Internal_ConcurUtil.loopInfinitely(workQueueWidget(state)(ui)(cache)), Widgets_Loading.loadingWidget ]);
        };
    };
};
export {
    UIStateChange,
    JumpToForm,
    workQueueWidget,
    workQueueWidgetWithRoute,
    loadingWidgetWQ
};
//# sourceMappingURL=index.js.map
